<label class="top-label field-label" [attr.for]="inputId">{{ rawLabel ?? (label | translate) }}</label>
<div class="reference-display-row">
  <!-- Stays flush so .reference-display-row is exactly the control's height and the projected
       button centres on the control rather than on the control-plus-reserve. The reserve itself is
       re-added on :host - see the padding-bottom note in the stylesheet. -->
  <mat-form-field class="tl-labelless-field tl-labelless-field--flush">
    <input matInput [id]="inputId" [value]="value || noneLabel" disabled />
  </mat-form-field>
  <ng-content></ng-content>
</div>
